export default {
    'ru_RU': {
        backToProducts: 'Назад к товарам',
        compareProducts: 'Сравнение товаров',
        emptyMsgTop: 'К сожалению, сравнивать пока нечего.',
        emptyMsgBottomStart: 'Для того чтобы сравнить понравившиеся вам товары, нажмите на значок сравнения ',
        emptyMsgBottomEnd: 'в категории или карточке товара',
        addProductsFromCategory: 'Добавить еще товары из данной категории',
        sameProducts: 'Аналоги',
        catalogLink: 'Каталог',
        delete: 'Удалить',
        moreAboutProduct: 'Подробнее о товаре',
        buy: 'Купить',
        showOnlyDifferencies: 'Показывать только различия',
        hold: 'Закрепить',
        addToWishlist: 'Добавить в вишлист',
        shareLinkText: 'Поделиться списком',
        linkCopied: 'Ссылка скопирована',
        error: 'Ошибка',
        clearAllProducts: 'Очистить список',
        noItem: 'Нет данных',
        currency: '₽',
        defaultName: 'Базовые характеристики',
        javascriptEnabled: 'Модуль сравнения товаров работает только с включенным Javascript. Пожалуйста, включите его в настройках.',
        of: 'из',
        outOfStock: 'Нет в наличии',
        loadingError: 'Ошибка при загрузке данных',
        removeProductError: 'Не удалось удалить товар',
    },
    'nl_NL': {
        backToProducts: 'Terug naar producten',
        compareProducts: 'Productvergelijking',
        emptyMsgTop: 'Helaas is er nog niets te vergelijken.',
        emptyMsgBottomStart: 'Om de gewenste producten te vergelijken, klikt u op het vergelijkingspictogram ',
        emptyMsgBottomEnd: 'in de categorie of productkaart',
        addProductsFromCategory: 'Voeg meer producten uit deze categorie toe',
        sameProducts: 'Analogen',
        catalogLink: 'Catalogus',
        delete: 'Verwijderen',
        moreAboutProduct: 'Productdetails',
        buy: 'Kopen',
        showOnlyDifferencies: 'Toon alleen verschillen',
        hold: 'Bevestig',
        addToWishlist: 'Zet op verlanglijst',
        shareLinkText: 'Lijst delen',
        linkCopied: 'Kopieer link',
        error: 'Fout',
        clearAllProducts: 'Lijst wissen',
        noItem: 'Geen gegevens',
        currency: '€',
        defaultName: 'Basiskenmerken',
        javascriptEnabled: 'Productvergelijking werkt alleen als Javascript is ingeschakeld. Schakel deze aub AAN in jouw instellingen.',
        of: 'van de',
        outOfStock: 'Niet beschikbaar',
        loadingError: 'Fout bij laden van gegevens',
        removeProductError: 'Kan item niet verwijderen',
    }
};
